import type { ImageLoader } from 'next/image';

const productImageLoader: ImageLoader = ({ src, width }) => {
  return `https://mds-dev.sprinx.cz/_transform?outputformat=webp&src=${encodeURIComponent(
    src,
  )}&width=${encodeURIComponent(width)}&resizefit=contain`;
};

export default productImageLoader;
